/**
 * Thin client for minesweeper_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'minesweeper';

export const MINES_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.minesweeper?.API_BASE || '')
    : '/mines';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Minesweeper GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createMinesSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${MINES_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveMinesSession(sessionId, { action = 'reveal', row, col } = {}) {
    const res = await fetch(`${MINES_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, row, col }),
    });
    return parseJson(res);
}

export async function deleteMinesSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${MINES_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const CELL_POINTS = 14;
export const VICTORY_BONUS = 450;

export const computeMinesweeperScore = (revealedSafe, isVictory = false) => (
    revealedSafe * CELL_POINTS + (isVictory ? VICTORY_BONUS : 0)
);
